// extracted by mini-css-extract-plugin
export default {"cta":"QG-z","disabled":"RG-z"};